import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'avanta';

  constructor(private router: Router, 
    private location: Location,
    @Inject(DOCUMENT) private dom: Document) {}
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      if (evt.url.match(/post/g) === null) {
        this.dom.body.scrollTop = 0;
        this.dom.documentElement.scrollTop = 0;
      }
    });
  }
}
